import PlayerFinder from "@/services/PlayerFinder";
const player = {
  state: () => ({
  }),
  getters: {},
  mutations: {
  },
  actions: {
    async registerFormHost({}, data) {
      return await PlayerFinder.addHostRegister(data);
    },
    async updateFormHost({}, data) {
      return await PlayerFinder.updateHost(data);
    },
    async searchPlayerFinder({}, data) {
      return await PlayerFinder.seekerSearchForm(data);
    },
    async getDataPlayerFinder({}) {
      return await PlayerFinder.getDataPlayerFinder();
    },
  },
};

export default player;
